/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".close-icon[_ngcontent-%COMP%]{position:absolute;left:15px;top:14px;border-radius:4px}.close-icon[_ngcontent-%COMP%]:hover{background-color:#f9f9f9}.fileuploader-image[_ngcontent-%COMP%]{margin-left:20px}"];
export { styles as styles };
